<mat-dialog-content class="icon-header mt-5">
  <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="{{(icon$ | async)}}" color="{{(iconColor$ | async)}}"></mat-icon>
  @if (isSuccessful$ | async) {
    <h1 i18n="payment-status-dialog|Payment successful header" mat-dialog-title>Payment Successful</h1>
    <p i18n="payment-status-dialog|Payment succeeded content.">
      Your payment has been successful. Please note that payment processing can take up to 15 minutes.
    </p>
  } @else if(isFailed$ | async) {
    <h1 i18n="payment-status-dialog|Payment failed header" mat-dialog-title>Payment failed</h1>
    <p i18n="payment-status-dialog|Payment failed content.">
      We're sorry, but it seems that there was an issue processing your payment. Please check your payment details and try again. If the
      problem persists, please contact our support team for assistance. We apologize for any inconvenience this may have caused.
    </p>
  }
  @else {
    <h1 i18n="payment-status-dialog|Already paid header" mat-dialog-title>Already paid</h1>
    <p i18n="payment-status-dialog|Already paid  content.">
      Thank you for your payment! It looks like we've already received your transaction. No further action is needed at this time.
      If you believe this is an error or have any questions, please feel free to contact our support team for assistance.
    </p>
  }
  <mat-dialog-actions align="center">
    <button mat-flat-button mat-dialog-close i18n="payment-status-dialog|Close modal button">Close</button>
  </mat-dialog-actions>
</mat-dialog-content>
